import React, { Component, FC, ReactNode } from 'react'
import { useLocation } from 'react-router-dom'

type ErrorBoundaryProps = {
  fallback: ReactNode
  resetKey?: string
}

type ErrorBoundaryState = {
  failed: boolean
}

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = { failed: false }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { failed: true }
  }

  componentDidUpdate(previous: ErrorBoundaryProps) {
    if (this.state.failed && previous.resetKey !== this.props.resetKey) {
      this.setState({ failed: false })
    }
  }

  render() {
    return this.state.failed ? this.props.fallback : this.props.children
  }
}

export const RouteErrorBoundary: FC<Pick<ErrorBoundaryProps, 'fallback'>> = ({
  fallback,
  children
}) => {
  const { pathname } = useLocation()

  return (
    <ErrorBoundary fallback={fallback} resetKey={pathname}>
      {children}
    </ErrorBoundary>
  )
}
